import { TableColumn } from "@pdf/helpers/default-table/table-column";
import { Headlines, ImagePaths, TableProperties } from "@pdf/pdf-properties";
import { jsPDF } from "jspdf";
import { FloorplanInformationTable } from "../floorplan-information-table";
import { CableRouteRow } from "./cable-route-row";

import { CableRoute } from "@domain/project/floorplan/wiring/cable-route";

export class CableRoutesRowHeaders {
  public readonly NUMBER = $localize`:@@pdfExport.cableRoutesTable.header.number:Nr.`;
  public readonly DISPLAY_NAME = $localize`:@@pdfExport.cableRoutesTable.header.displayName:Anzeigename`;
  public readonly NAME = $localize`:@@pdfExport.cableRoutesTable.header.name:Name`;
  public readonly CONSTRUCTION_KIT = $localize`:@@pdfExport.cableRoutesTable.header.constructionKit:Bausatz`;
  public readonly REFERENCE_LENGTH = $localize`:@@pdfExport.cableRoutesTable.header.referenceLengthInMeter:Länge [m]`;
  public readonly NOTES = $localize`:@@pdfExport.cableRoutesTable.header.notes:Notizen`;
}

export class CableRoutesTable extends FloorplanInformationTable {
  readonly headlines = new Headlines();
  readonly rowHeaders = new CableRoutesRowHeaders();
  override readonly headline = this.headlines.CABLE_ROUTES;
  override readonly columns: TableColumn[];
  override readonly rows: CableRouteRow[];

  constructor(pdf: jsPDF, cableRoutes: CableRoute[]) {
    super(ImagePaths.CABLE_ROUTE);
    this.columns = [
      new TableColumn(this.rowHeaders.NUMBER, 60, 96),
      new TableColumn(this.rowHeaders.DISPLAY_NAME, 180, 156),
      new TableColumn(this.rowHeaders.NAME, 360, 136),
      new TableColumn(this.rowHeaders.CONSTRUCTION_KIT, 520, 146),
      new TableColumn(this.rowHeaders.REFERENCE_LENGTH, 690, 176),
      new TableColumn(this.rowHeaders.NOTES, 850, 590),
    ];

    this.rows = cableRoutes.map((cableRoute) => {
      const cableRouteLength =
        cableRoute.isReferenceMeasureSet() && cableRoute.referenceLength ? `${cableRoute.referenceLength}` : "";

      return new CableRouteRow(
        pdf,
        this.textToColumnWidth(
          pdf,
          TableProperties.TEXT_FONT_SIZE,
          this.preProcessText(cableRoute.positionId),
          this.rowHeaders.NUMBER,
        ),
        this.textToColumnWidth(
          pdf,
          TableProperties.TEXT_FONT_SIZE,
          this.preProcessText(cableRoute.displayName),
          this.rowHeaders.DISPLAY_NAME,
        ),
        this.textToColumnWidth(pdf, TableProperties.TEXT_FONT_SIZE, this.preProcessText(cableRoute.name), this.rowHeaders.NAME),
        this.textToColumnWidth(
          pdf,
          TableProperties.TEXT_FONT_SIZE,
          this.preProcessText(cableRoute.constructionKit ? "Bausatz" : "Kein Bausatz"),
          this.rowHeaders.CONSTRUCTION_KIT,
        ),
        this.textToColumnWidth(
          pdf,
          TableProperties.TEXT_FONT_SIZE,
          this.preProcessText(cableRouteLength),
          this.rowHeaders.REFERENCE_LENGTH,
        ),
        this.textToColumnWidth(pdf, TableProperties.TEXT_FONT_SIZE, this.preProcessText(cableRoute.notes), this.rowHeaders.NOTES),
      );
    });
    this.height = this.calculateHeight(this.rows);
  }
}
